import {
  GetIdentityByIdentityIDRequest,
  GetIdentityByIdentityIDResponse,
  GetUsersByIdentityIDRequest,
  GetUsersByIdentityIDResponse,
  IdentityLoginInfoAsAdminRequest,
  IdentityLoginInfoAsAdminResponse,
} from "@safetyculture/s12-apis-connect-web/s12/identity/admin/v1/identity_management_pb";
import {
  UpdatePreferredOrgRequest,
  UpdatePreferredOrgResponse,
} from "@safetyculture/s12-apis-connect-web/s12/identity/v1/authentication_service_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

export type ListUsersByIdentityIDParams = {
  identityId: string;
};

export const listUsersByIdentityID = async (
  { identityId }: ListUsersByIdentityIDParams,
  headers: Record<RequestMetadata, string>,
): Promise<GetUsersByIdentityIDResponse> => {
  const req = new GetUsersByIdentityIDRequest({
    identityId,
  });

  return supportServiceConnectClient.getUsersByIdentityID(req, { headers });
};

export type GetIdentityByIdentityIDParams = {
  identityId: string;
};

export const getIdentityByIdentityID = async (
  { identityId }: GetIdentityByIdentityIDParams,
  headers: Record<RequestMetadata, string>,
): Promise<GetIdentityByIdentityIDResponse> => {
  const req = new GetIdentityByIdentityIDRequest({
    identityId,
  });

  return supportServiceConnectClient.getIdentityByIdentityID(req, { headers });
};

type UpdatePreferredOrgParams = {
  identityId: string;
  preferredOrgId: string;
};

export const updatePreferredOrg = async (
  { identityId, preferredOrgId }: UpdatePreferredOrgParams,
  headers: Record<RequestMetadata, string>,
): Promise<UpdatePreferredOrgResponse> => {
  const req = new UpdatePreferredOrgRequest({
    identityId,
    preferredOrgId,
  });

  return supportServiceConnectClient.updatePreferredOrg(req, { headers });
};

type IdentityLoginInfoAsAdminParams = {
  identityId: string;
};

export const getIdentityLoginInfo = async (
  { identityId }: IdentityLoginInfoAsAdminParams,
  headers: Record<RequestMetadata, string>,
): Promise<IdentityLoginInfoAsAdminResponse> => {
  const req = new IdentityLoginInfoAsAdminRequest({
    identityId,
  });

  return supportServiceConnectClient.identityLoginInfoAsAdmin(req, { headers });
};
